/**
 * Keeps the original wishlist app control over the gallery across variant morphs.
 */
class OneAWishlistPlacement extends HTMLElement {
  connectedCallback() {
    this.observer?.disconnect();
    this.observer = new MutationObserver(() => this.placeWishlist());
    this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
    this.placeWishlist();
  }
  disconnectedCallback() { this.observer?.disconnect(); }
  placeWishlist() {
    const gallery = this.querySelector('.product-information__media media-gallery');
    const freshControl = this.querySelector('.product-details .shopify-app-block .wishlist-engine[data-full_button="true"]');
    if (freshControl) this.wishlistBlock = freshControl.closest('.shopify-app-block');
    const block = this.wishlistBlock;
    const control = block?.querySelector('.wishlist-engine');
    if (!gallery || !block || !control) return;
    const input = this.querySelector('.product-details input[name="id"]');
    if (input?.value) control.setAttribute('data-variant_id', input.value);
    gallery.classList.add('one-a-wishlist-photo-host');
    block.classList.add('one-a-wishlist-photo-button');
    if (control.tagName !== 'BUTTON' && !control.hasAttribute('data-one-a-keyboard')) {
      control.setAttribute('role', 'button');
      control.tabIndex = 0;
      control.setAttribute('data-one-a-keyboard', '');
      control.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          control.click();
        }
      });
    }
    if (block.parentElement !== gallery) gallery.append(block);
  }
}
if (!customElements.get('one-a-wishlist-placement')) {
  customElements.define('one-a-wishlist-placement', OneAWishlistPlacement);
}
